<!-- Center canvas: summary, text typed into directly, matches Main Banner/Intro + CTA/Big Headline's badge+card pattern -->
<div
  class="cr-oi-card"
  *ngIf="isPreview"
  [id]="block.blockId"
>
  <span class="cr-oi-badge">Only Intro</span>

  <span
    class="cr-oi-value"
    [appInlineEdit]="block.variables?.OnlyIntro ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert Intro Text"
    [inlineEditMultiline]="true"
    (inlineEditChange)="onChange($event, 'OnlyIntro')"
  ></span>
</div>

<!-- Right panel: real edit form -->
<div class="cr-oi-edit" *ngIf="!isPreview">
  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.OnlyIntro ?? ''"
    (handleOnChange)="onChange($event, 'OnlyIntro')"
    [placeholder]="onlyIntroPlaceholder"
    [maxLength]="4000"
    variable="OnlyIntro"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
